// The design-system primitives (hand-built, tokens + CSS Modules, no styled kit).
// Import app-wide as `@/components/ui`. See docs/DESIGN_SYSTEM.md "Component library".
export { Avatar } from './avatar';
export { AvatarStack } from './avatar-stack';
export { Button, type ButtonProps, type ButtonSize, type ButtonVariant } from './button';
export {
  Chip,
  chipToneOf,
  type ChipLead,
  type ChipLook,
  type ChipPopup,
  type ChipProps,
  type ChipSize,
  type ChipTone,
  type ChipTrail,
} from './chip';
export { ChipInput, type ChipInputItem } from './chip-input';
export { Dialog } from './dialog';
export { Disclosure } from './disclosure';
export { Field } from './field';
export { HelpTip } from './help-tip';
export { Highlight } from './highlight';
export { IconButton, type IconButtonProps, type IconButtonSize } from './icon-button';
export { Tick, type TickProps } from './tick';
export { Input, type InputProps, type InputSize } from './input';
export { LoadMore } from './load-more';
export { Menu, MenuRows, type MenuActionItem, type MenuItem } from './menu';
export { MultiSelect } from './multi-select';
export { Notice } from './notice';
export { OverlayFoot } from './overlay-foot';
export { useOverlayBusy } from './overlay-busy';
export { PageTitle } from './page-title';
export { ProseEditor, type ProseEditorProps, type ProseMode } from './prose-editor';
export { Property, PropertyList } from './property-list';
export { DateOnly, RelativeTime } from './relative-time';
export { SegmentedControl, type SegmentOption } from './segmented-control';
export { Select, type SelectOption } from './select';
export { Sheet } from './sheet';
export { Skeleton, SkeletonRegion, type SkeletonProps } from './skeleton';
export { SplitPill } from './split-pill';
export { Spinner, type SpinnerProps } from './spinner';
export { Textarea, type TextareaProps } from './textarea';
export { Tooltip } from './tooltip';
export { attachSwipeToDismiss, type SwipeToDismissOptions } from './swipe-to-dismiss';
export { useAnchored } from './use-anchored';
export { useInView, REDUCED_MOTION_QUERY } from './use-in-view';
export { useNow } from './use-now';
export { usePopover, type PopoverApi } from './use-popover';
export {
  useViewport,
  type ViewportFlags,
  PHONE_MAX_PX,
  SMALL_PHONE_MAX_PX,
  TABLET_MAX_PX,
  WIDE_MIN_PX,
  COMPACT_QUERY,
  WIDE_QUERY,
  NARROW_QUERY,
  COARSE_POINTER_QUERY,
} from './use-viewport';
